import {
    Component,
    EventEmitter,
    Input,
    input,
    Output,
    output
} from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";

@Component({
    selector: "app-order-visualizations-options",
    imports: [SharedDsnModule, SharedMaterialModule],
    templateUrl: "./order-visualizations-options.component.html",
    styleUrl: "./order-visualizations-options.component.scss"
})
export class OrderVisualizationsOptionsComponent {
    @Input({ required: true }) options: Option[];
    @Input({ required: false }) value: string;
    @Output() handleSelectOption = new EventEmitter<Option>();
}

type Option = {
    value: string;
    label: string;
};
